import '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { NgForm,FormsModule } from '@angular/forms';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { Router,NavigationEnd,ActivatedRoute } from '@angular/router';
declare  var jQuery:  any;

@Component({
  selector: 'app-singup',
  templateUrl: './singup.component.html',
  styleUrls: ['./singup.component.scss']
})
export class SingupComponent implements OnInit {
  registerRequest: any= {};
	registerError: any;
  registerSuccess: any;
  registersocError: any;
  registersocSuccess: any;
  userDetails: any = {};
  loginRequest: any= {};
  loginError: any;
  constructor(
  public authService: AuthService,
  private router: Router,
  ) { }

  ngOnInit() {
  this.registerRequest = {
      devices_id: new Date().getTime(),
      devices_name: navigator.userAgent,
      app_version: 1,
      devices_type: 'Web',
      login_type: 'Normal',
      os: 'Android10',
      is_signup: 'WP_USER',
      devices_token : 'abceajlkdlfka'
    }
    this.loginRequest = {
      devices_id: new Date().getTime(),
      devices_name: navigator.userAgent,
      app_version: 1,
      devices_type: 'Web',
      os: 'Android10',
     devices_token : 'abceajlkdlfka'
    }
    jQuery(".custom-select-list li").click(function(){
    var currentcontname = jQuery(this).find(".name").html();
    var currentcontcode = jQuery(this).find(".number").html();
    var currentflag = jQuery(this).find("span").eq(0).attr("class");
    jQuery(".custom-select-top a.selected_cont span").removeClass();
    jQuery(".custom-select-top a.selected_cont span").addClass(currentflag);
    jQuery("#country_code").val(currentcontcode);
    jQuery("#country_name").val(currentcontname);

  });
  jQuery(".custom-select-list-two li").click(function(){
    var currentcontname = jQuery(this).find(".name").html();
    var currentcontcode = jQuery(this).find(".number").html();
    var currentflag = jQuery(this).find("span").eq(0).attr("class");
    jQuery(".custom-select-top-two a.selected_cont span").removeClass();
    jQuery(".custom-select-top-two a.selected_cont span").addClass(currentflag);
    jQuery("#country_code_change").val(currentcontcode);
    jQuery("#country_name_change").val(currentcontname);

  });
  jQuery(".custom-select-top a").click(function(){
    jQuery(".custom-select").addClass("main");
  });
  jQuery(".custom-select-top-two a").click(function(){
    jQuery(".custom-select-two").addClass("main");
  });
  jQuery(".custom-select-list li a").click(function(){
    jQuery(".custom-select").removeClass("main");
  });
  jQuery(".custom-select-list-two li a").click(function(){
    jQuery(".custom-select-two").removeClass("main");
  });
  }
  doSignup(form: NgForm){
    this.authService.registerSuccess = null
    if (form.valid) {
      console.log(this.registerRequest.email);
      let request:any = {
       
      };
      request = Object.assign({}, this.registerRequest);
      //console.log(request);
      this.authService.register(request).then(
        (res) => {
          console.log(res);
          if(res.status==0)
          {
            this.registerError = res.message;
          }else{
            this.loginRequest = {
              devices_id: new Date().getTime(),
              devices_name: navigator.userAgent,
              app_version: 1,
              devices_type: 'Web',
              os: 'Android10',
              email: this.registerRequest.email,
              password: this.registerRequest.password
            };
            let request:any = {

            };
            request = Object.assign({}, this.loginRequest);
            this.authService.login(request).then(async (_res) => {

              this.router.navigate(['/clubsponsorship']);

             }).catch((err) => {
                //console.log({ err });
                this.loginError = err;
              });
          }
            
        
        }).catch((err) => {
          console.log(err);
          this.registerError = err.error.message;
        });
    }
  }
}
